import React, { useEffect, useState } from 'react';

import { Flex, Grid, Label, mediaQueries } from '@zeal/web-ui';

import NavMenu from './components/NavMenu';
import CarouselCard from './components/CarouselCard';
import { useMediaQuery, useTranslation } from '@zeal/zeal-lib';
import MobileBanner from './components/MobileBanner';
import BrandedContent from '@modules/Shared/Components/Branded/BrandedContent';
import ZealLogo from '@app/Components/Shared/ZealLogo';

export default function MagicLinkLayout({
	children,
}: {
	children: React.ReactNode;
}) {
	const isDesktop = useMediaQuery(mediaQueries.min.md);
	const { t } = useTranslation('common');

	const [isMounted, setIsMounted] = useState(false);

	useEffect(() => {
		setIsMounted(true);
	}, []);

	if (!isMounted) return null;

	return (
		<Grid cols={isDesktop ? 2 : 1} className="w-screen h-screen">
			{isDesktop && <CarouselCard />}
			<Flex isColumn>
				<NavMenu />
				{!isDesktop && <MobileBanner />}
				{children}
				{!isDesktop && (
					<BrandedContent
						brandedContent={
							<Flex
								align="center"
								justify="center"
								gap="2"
								className="w-full py-1"
							>
								<ZealLogo fill="black" />
								<Label.Mid200 textAlign="center">
									{t('powered_by_zeal', {
										ns: 'common',
									})}
								</Label.Mid200>
							</Flex>
						}
					/>
				)}
			</Flex>
		</Grid>
	);
}
